import { CommentItem } from "pages/api/discuss/debate/[discussId]";
import DebateUserProfile from "./Comment/Profile";
import DebateContentIndex from "./Comment/Content/Index";
import { useRouter } from "next/router";

// 토론 디테일 댓글 레이아웃
function MainCommentTemplete({ data }: { data: CommentItem }) {
  const router = useRouter();
  return (
    <div
      className="gap-2 flex items-stretch "
      data-test-id="main-comment-templete"
      data-parent-id={data?.parent_id}
      data-id={data?.comment_id}
    >
      <div className="flex flex-col ">
        <DebateUserProfile data={data} type="comment" />
      </div>
      <div className="flex flex-col grow">
        <div className={`flex flex-col gap-1 py-2 h-full`}>
          <DebateContentIndex data={data} type="comment" />
        </div>
      </div>
    </div>
  );
}

export default MainCommentTemplete;
